// Direktiva na renderovanie podaneho tiketu - historia tiketov
directives.ticketDetailDirective.ticketStatus = function() {
    var localizedTip1 = "1", localizedTip2 = "2", directive = {
        "#statusGUID": function () {
            if (profile.TipsFormat) {
                // Domaci, hostia
                localizedTip1 = texts["EventTip-1"];
                localizedTip2 = texts["EventTip-2"];
            }
            // Ulozi naskenovany tiket
            stored.OriginalInputTicket = this;
            return this.GUID;
        },
        "#statusBetValue": function () {
            return shared.floor2(this.OverallTotalBet, 1) + " " + profile.Currency;
        },
        "#statusFee@class": function () {
            if (!profile.DisplayFee || !this.OverallFee) return "hide-element";
        },
        "#statusFee #statusFeePercent": function () {
            return this.FeeRate + "%";
        },
        "#statusFeeValue": function () {
            return shared.floor2(this.OverallFee, 1) + " " + profile.Currency;
        },
        "#statusBetPlace": function () {
            if (this.Ref !== offer.platform) {
                // Tiket podany na inej platforme ako sportbox
                return texts.StatusOtherPlatformFullText;
            } else if (profile.OtherLocationShow && !this.IsLocationOK) {
                // Tiket podany na inej prevadzke
                return texts.StatusOtherLocationFullText;
            }
        },
        "#statusDepositValue": function () {
            return shared.floor2(this.OverallBet, 1) + " " + profile.Currency;
        },
        "#statusRate@class": function () {
            if (this.IsLotteryTicket == true) {
                return "hide-element";
            }
        },
        "#statusRateMultiplier@class": function () {
            if (this.BonificationValue <= 1) return "hide-element";
        },
        "#statusRateMultiplierValue": function () {
            if (this.BonificationValue > 1) return shared.floor2(this.BonificationValue, 2);
        },
        "#statusRateValue": function () {
            if (this.TYPE === ticket.state.ticketWsTypes.SRT && this.BusinessRate) {
                return shared.formatNumber(shared.floor2(this.BusinessRate, 2), true);
            } else if (this.IsBuyBack) {
                return shared.formatNumber(shared.floor2(this.OverallRateTicket, 2), true);
            }
            return shared.formatNumber(shared.floor2(this.OverallRate, 2), true);
        },
        "#statusBoosterBonusWrapper@class": function () {
            // Ak nieje booster bonus value na tikete skryje riadok s booster bonusom
            if (!this.BoosterBonusValue) return "hide-element";
        },
        "#statusBoosterBonusWrapper .bonus-tooltip@onmousedown": function () {
            if (this.BoosterBonusValue && profile.BoosterBonusName === "XXL") {
                // Tooltip icon zobrazi len v priapade ze sa jedna o XXL bonus (SVK, STG farma)
                if (profile.Resolution === "1280x1024") {
                    return "modal.showTooltip(this, false, true, 251, 67);";
                } else {
                    return "modal.showTooltip(this, false, true, 75);";
                }
            }
        },
        "#statusBoosterBonusWrapper .bonus-tooltip@class+": function () {
            if (this.BoosterBonusValue && profile.BoosterBonusName === "XXL") {
                // Tooltip nastavi len v priapade ze sa jedna o XXL bonus (SVK, STG farma)
                return " icon icon-info-circle";
            }
        },
        "#statusBoosterBonusWrapper #bonusLabelValue": function () {
            if (this.BoosterBonusValue) {
                return shared.floor2(this.BoosterBonusValue, 1) + " " + profile.Currency;
            }
        },
        "#statusBoosterBonusWrapper #bonusLabel@class": function () {
            if (!this.BoosterBonusValue) {
                return "ui-disabled";
            }
        },
        "#statusSuperBankWrapper@class": function () {
            if (!this.SuperBankValue) return "hide-element";
        },
        "#statusSuperBankWrapper #superBankText": function () {
            if (this.SuperBankDesc) {
                // Custom nazov pre jackpot
                return this.SuperBankDesc;
            } else {
                // Default nazov "Jackpot" (LBR)
                return texts.JackpotDefaultLabel;
            }
        },
        "#statusSuperBankWrapper #superBankValue": function () {
            if (this.SuperBankValue) {
                return shared.floor2(this.SuperBankValue, 1) + " " + profile.Currency;
            }
        },
        "#statusSumText": function () {
            if ((this.Status === "Paid" || this.Status === "Won") && (this.IsLotteryTicket || !(this.OddsCombi.length))) {
                // Ak je ticket vyherny a sucasne sa nejedna o kombi ticket zobrazi "vyhra""
                return texts.StatusTicketWin;
            } else {
                // Zobrazi "mozna vyhra"
                return texts.CalcWin;
            }
        },
        "#statusSumValue": function () {
            return shared.floor2(this.FiscalOverallPotWin, 1) + " " + profile.Currency;
        },
        "#statusSum@class": function () {
            if (this.IsNoRiskTicket) {
                return "ticket-No-risc";
            } else if (this.isStoredTicket) {
                return "ticket-Saved";
            }
            return "ticket-" + (this.Status? this.Status: this.PlaceBetState);
        },
        "#ctActualWin@class": function () {
            if (!this.OddsCombi.length || this.isStoredTicket || this.IsLotteryTicket) {
                return "hide-element";
            } else if (this.Status == "Lost" || this.Status == "Canceled") {
                return "ticket-Lost";
            }
        },
        "#ctActualWinValue": function () {
            if (this.OddsCombi.length) {
                return shared.floor2(this.AmountMoneyWon, 1) + " " + profile.Currency;
            }
        },
        "#statusBetDateValue": function () {
            if (this.PlaceBetDate) return this.PlaceBetDate;
        },
        "#statusBetDate@class": function () {
            if (this.isStoredTicket || this.PlaceBetState === "edited") return "hide-element";
        },
        "#statusExpirationDateValue": function () {
            if ((this.Status === "expired" || this.IsPayable) && this.ExpiresAt) {
                var expiration = new Date(this.ExpiresAt);
                return (this.ExpiresAt.substr(8, 2) + "." + this.ExpiresAt.substr(5, 2) + "." + this.ExpiresAt.substr(0, 4) + "  " + expiration.toLocaleTimeString(['sk'], { hour: '2-digit', minute: '2-digit' }));
            }
        },
        "#statusBetVersion": function () {
            if (this.PlaceBetState === "edited") {
                return texts.TicketEditVersionLabel + " " + this.EditedVersion;
            } else {
                return "";
            }
        },
        "#statusBetVersion@class": function () {
            if (this.PlaceBetState !== "edited") return "hide-element";
        },
        "#statusValue": function () {
            if (this.PlaceBetState !== "approved") {
                // Ak je tiket v inom stave ako approved tak zrusi automaticky reload ticket statusu
                clearTimeout(rfs.ticketStatusReload);
                delete rfs.ticketStatusReload;
            }

            // Najprv zablokuje a schova vsetky tlacitka, nasledne zobrazi tie ktore je mozne pouzit
            $("#ticketStatus .status-buttons").find("a, #buyBackWarning, #manualRedeemTooltip, #autoRedeemTooltip, #ticketRedeemNotAllowed").addClass("ui-disabled").hide();
            if (this.isStoredTicket) {
                return texts.StatusTicketSaved;
            } else if (stored.TicketCode && this.Status) {
                // Otvaranie tiketu cez ticketCode - vypise len status tiketu
                return texts["StatusTicket" + this.Status];
            }

            // Zobrazi a enabluje spravne tlacitka
            if (profile.TicketStatusPrintTicket && !this.IsBuyBack && stored.ticketDetailFromMyTickets) {
                // Neodkupeny tiket ktory bol zobrazeny prostrednictvom mojich tiketov
                $("#ticketStatus .ticket-print").removeClass("ui-disabled").show();
            }

            if (profile.ClientStorno && this.IsCancelable) {
                // Nevyhodnoteny a stornovatelny tiket
                $("#ticketStatus .ticket-storno").removeClass("ui-disabled").show();
            }
            // Vyhodnoteny pripadne aj vyplateny tiket alebo stornovany tiket
            if (this.IsPayable) {
                if (profile.TicketStatusPrintCredit) {
                    // Zobrazi moznost prevodu na kartu a vytlacenie kreditneho listka
                    $("#ticketStatus .credit-to-balance, #ticketStatus .credit-cash-back").removeClass("ui-disabled").show();
                } else {
                    // Zobrazi len moznost prevodu na kartu
                    $("#ticketStatus .credit-to-balance").removeClass("ui-disabled").show();
                }
                // Ak nie je hrac prihlaseny, nastavime moznost prevodu na online ucet podla profilu
                if (stored.allowTransferMoneyToOnline === undefined) {
                    stored.allowTransferMoneyToOnline = profile.TicketStatusPayableToOnline;
                }
                if (stored.allowTransferMoneyToOnline && profile.TicketStatusPayableToOnline && this.PlayerHasOnlineAccount) {
                    $("#ticketStatus .credit-to-online").removeClass("ui-disabled").show();
                }
            } else if (this.Status == "Canceled") {
                $("#ticketStatus .ticket-storno").show();
            } else {
                // Kontrola moznosti odpredaja tiketu
                if (!this.IsBuyBack && this.TYPE == ticket.state.ticketWsTypes.JT) {
                    ticketDetail.ticketRedeem();
                }
            }
            // Moznost zopakovat tiket (riadi tiketova sluzba)
            if (this.IsCloneable) {
                $("#ticketStatus .ticket-repeat").removeClass("ui-disabled").show();
            }
            // Moznost editovat tiket
            if (profile.EditTicket && this.IsEditable) {
                $("#ticketStatus .ticket-edit").removeClass("ui-disabled").show();
            }
            // Zobrazi stav tiketu s info ci bol podany na inej pobocke
            if (this.IsNoRiskTicket) {
                return texts["StatusTicketNoRisc"];
            } else if (this.IsBuyBack && this.Status == "Won") {
                return texts["StatusTicketRedeemed"];
            } else if (this.PlaceBetState == "edited") {
                return texts.StatusTicketEdited;
            } else {
                return texts["StatusTicket" + this.Status];
            }
        },
        "#statusValueAdditional": function () {
            if (this.IsNoRiskTicket && !this.IsPayable) {
                return texts.StatusTicketNoRiscPaid;
            }
        },
        "#statusValue@class": function () {
            if (this.IsNoRiskTicket) {
                return "ticket-No-risc";
            } else if (this.isStoredTicket) {
                return "ticket-Saved";
            }
            return "ticket-" + (this.Status? this.Status: this.PlaceBetState);
        },
        "#statusPayable": function () {
            if (this.PayoutDate) return texts.StatusPayable + ": <span>" + this.PayoutDate + "</span>"
        },
        "#statusPayable@class": function () {
            if (this.isStoredTicket) return "hide-element";
        },
        "#ticketStatusIcon@class+": function () {
            var icon = " ";
            if (this.PlaceBetState === "edited") {
                return icon += "Edited-ico";
            } else if (this.IsCompensationTicket) {
                return icon += "Compensation-ico";
            } else if (this.IsBuyBack) {
                return icon += "Buyback-ico";
            } else if (this.IsNoRiskTicket) {
                return icon += "No-risc-ico";
            } else if (this.Status === "Paid") {
                return icon += "Won-ico";
            } else if (this.isStoredTicket) {
                return icon += "Saved-ico";
            } else {
                return icon += this.Status + "-ico";
            }
        },
        "#ticketStatusPie@style": function (a) {
            if (!profile.CountGraphStates.length || !profile.CountGraphStates.includes(this.Status)) {
                this.showGraph = false;
            } else {
                this.showGraph = true;
                a.context.countgraphdata = [];
                if (this.lostCount) a.context.countgraphdata.push({
                    'name': 'loss',
                    'colorStarts': '#AB0024',
                    'colorEnds': '#F47900',
                    'bubble': '#F40034',
                    'count': this.lostCount
                });
                if (this.winCount) a.context.countgraphdata.push({
                    'name': 'win',
                    'colorStarts': '#45B00C',
                    'colorEnds': '#EAFA82',
                    'bubble': '#76CE27',
                    'count': this.winCount
                });
                if (this.pendCount) a.context.countgraphdata.push({
                    'name': 'pend',
                    'colorStarts': '#006DB2',
                    'colorEnds': '#5FC1FF',
                    'bubble': '#2EA3EE',
                    'count': this.pendCount
                });
                a.context.graphData = ticketDetail.generateCountGraphBG(a.context.countgraphdata, 0, 100);
                return "background: conic-gradient(" + a.context.graphData.gradientContent + ")";
            }
        },
        "#countGraphPie@style": function (a) {
            if (this.showGraph && a.context.graphData && a.context.graphData.gradientContent) {
                return "background: conic-gradient(" + a.context.graphData.gradientContent + ")";
            }
        },
        "#countGraphLegendLoss": function () {
            if (this.showGraph && this.lostCount) {
                return "<div id='legendLossCircle' class='count-graph-legend-circle'></div>" + texts.StatusGraphLegendLost;
            }
        },
        "#countGraphLegendWin": function () {
            if (this.showGraph && this.winCount) {
                return "<div id='legendWinCircle' class='count-graph-legend-circle'></div>" + texts.StatusGraphLegendWin;
            }
        },
        "#countGraphLegendPend": function () {
            if (this.showGraph && this.pendCount) {
                return "<div id='legendPendCircle' class='count-graph-legend-circle'></div>" + texts.StatusGraphLegendPend;
            }
        },
        "#countGraphInfoIcon@class+": function () {
            if (!this.showGraph) {
                return "ui-disabled";
            }
        },
        "#oddHeaderName@class+": function (a) {
            if (this.Odds.length <= 1) {
                return "no-sorting";
            }
        }
    }
    T.ticketStatus = $p("#ticketStatus #section").compile(directive);
};

// Direktiva na rendrovanie oddov v detaile tiketu
directives.ticketDetailDirective.ticketStatusOdds = function() {
    var directive = {
        ".ui-status": {
            filter: function (a) {
                // Modifikujem prijate data pre loterie aby sedeli v zobrazeni detailu 
                if (this.RegionID == profile.Lottery.RegionID) {
                    try {
                        return ticket.ticketLotteryModule.parseLottery(this, a.context);
                    } catch (e) {
                        console.warn(e);
                    }
                }
            },
            "Odd<-Odds": {
                ".@id": function (a) {
                    this.Score = shared.parseScore(this.SCORENEW, this.SportID);
                    return "HO" + (a.pos + 1);
                },
                ".@onclick": function (a) {
                    if (a.context.IsLotteryTicket && this.collapsibleRow == true) {
                        return 'lottery.eventDetailLottery.toggle(this)';
                    }
                    if (profile.FlatCSS && this.EVT && this.SportID != offer.vgID && this.EventResultsType) {
                        if (profile.Results && this.EventResultsType === "results") {
                            return 'eventDetail.showEventDetail(' + this.EVT + ', "results")';
                        } else if (this.EventResultsType === "offer") {
                            if (this.LiveBet) {
                                return 'eventDetail.showEventDetail(' + this.EVT + ', "live")';
                            } else {
                                return 'eventDetail.showEventDetail(' + this.EVT + ', "sportsBook")';
                            }
                        }
                    }
                },
                "+.live-odd": function (a) {
                    var oddLabel = '';
                    if (this.LiveBet) oddLabel = '<div class="odd-live">L</div>';
                    if (this.SportID == offer.vgID) oddLabel = '<div class="odd-virtual">v</div>';
                    if (a.context.IsLotteryTicket) oddLabel = '';
                    return oddLabel;
                },
                ".odd-group": function (a) {
                    var oddLabel = '';
                    if (a.context.IsLotteryTicket) return;
                    if (this.Group && this.Group.length) {
                        if (a.context[a.pos - 1] && a.context[a.pos - 1].Group === this.Group) oddLabel += '<div class="group-line-top"></div>';
                        if (a.context[a.pos + 1] && a.context[a.pos + 1].Group === this.Group) oddLabel += '<div class="group-line-bottom"></div>';
                        oddLabel += '<div class="group-name">' + this.Group + '</div>';
                    }
                    return oddLabel;
                },
                ".odd-group@class+": function (a) {
                    if (this.Group === "1") {
                        return " odd-groupT";
                    }
                },
                ".title-root": function (a) {
                    if (a.context.IsLotteryTicket) {
                        return `</span><span class="title-root sport-bgColor-${this.LCUP}">${this.LeagueCupName}</span><span class="title-root sport-bgColor-${this.LCUP}">${this.EventName}`;
                    } else {
                        return this.SportName + ' | ' + this.RegionName + ' | ' + this.LeagueCupName;
                    }
                },
                ".title-root@class+": function () {
                    return " sport-bgColor-" + this.SportID;
                },
                ".title-home": "Odd.Team1",
                ".vs": function () {
                    if (this.Team2) return "VS ";
                },
                ".title-away": "Odd.Team2",
                // [Betbuilder Aggregator API] Ikona pri nazve zapasu
                ".betbuilder-agg__icon-placeholder": function () {
                    if (profile.BetBuilderAgg && this.IsBetbuilder) {
                        return '<span class="icon icon-betbuilder--agg"></span>';
                    }
                },
                ".title-chance-type": function () {
                    if (this.ChanceType) {
                        // [Betbuilder Aggregator API] Formatovany ChanceType pre oddy z Betbuilder
                        if (profile.BetBuilderAgg && this.IsBetbuilder) {
                            return betbuilderAgg.formatAggregatorChanceType(this.ChanceType);
                        }
                        return this.ChanceType;
                    }
                },
                ".icon@onmousedown": function () {
                    if (this.EventExtInfo) {
                        this.tooltipText = "";
                        if (this.EventExtInfo.EventComment) this.tooltipText += this.EventExtInfo.EventComment + "<br>";
                        if (this.EventExtInfo.AggregateScore) this.tooltipText += texts.AggregateScoreText + " <b>" + this.EventExtInfo.AggregateScore + "</b><br>";
                        if (this.EventExtInfo.SeriesResult) this.tooltipText += texts.SeriesResultText + " <b>" + this.EventExtInfo.SeriesResult + "</b> ";

                        if (this.tooltipText) {
                            if (profile.Resolution === "1280x1024") {
                                return "modal.showTooltip(this, '" + this.tooltipText + "', false, 115)";
                            } else {
                                return "modal.showTooltip(this, '" + this.tooltipText + "', false, 2)";
                            }
                        }
                    }
                },
                ".icon@class+": function () {
                    if (this.tooltipText) {
                        return " icon-info-circle";
                    }
                },
                ".odd-result@class+": function () {
                    if (this.Score.isOverallEvent) {
                        return ' overall-event';
                    }
                },
                ".total-result": function (a) {
                    if (a.context.IsLotteryTicket) {
                        return shared.floor2(this.PotWin, 1) + " " + profile.Currency;
                    }
                    if (this.Score.isOverallEvent) {
                        return this.Score.total.replace(/, /g, "<br>");
                    }
                    return this.Score.total;
                },
                ".parcial-result": function () {
                    if (this.Score.parcial) {
                        return "(" + this.Score.parcial + ")";
                    }
                },
                ".score-shoot-out": function () {
                    if (!this.liveBet || this.EventStatus === "ended") {
                        if (this.Score.penalties && this.SportID == 53) return "(" + texts.EventScoreShootOut + ")";
                        if (this.Score.penalties) return "(" + texts.EventScorePenalty + ")";
                        if (this.Score.overtime) return "(" + texts.EventScoreOverTime + ")";
                    }
                },
                ".game-score": function () {
                    if (offer.parcialScoreSports.includes(this.SportID) && this.EventStatus !== "ended" && this.Score && this.Score.Home.game && this.Score.Away.game) return this.Score.Home.game + ":" + this.Score.Away.game;
                },
                ".game-score@class+": function () {
                    if (offer.parcialScoreSports.includes(this.SportID) && this.EventStatus !== "ended" && this.Score && this.Score.service) {
                        return " " + this.Score.service;
                    }
                },
                ".date": "Odd.DATE",
                ".bet": function (a) {
                    return ticket.getLocalizedTip(this.Tip, this.Team1, this.Team2, a.context.IsLotteryTicket, true);
                },
                ".odd-state@class+": function (a) {
                    var oddStatus = this.IsWinning;
                    if (a.context.IsEdited && !a.context.IsBuyBack && this.IsWinning === "BB") {
                        // BuyBack Edited Ticket a neodkupeny
                        oddStatus= "BBET";
                    }
                    return ` ${a.context.IsLotteryTicket ? "odd-lottery" : ""} odd-status-${oddStatus}`;
                },
                ".state": function (a) {
                    if (a.context.IsBuyBack) {
                        return texts["StatusTicketRedeemed"].toLowerCase();
                    } else {
                        return texts["OddStatus_" + this.IsWinning];
                    }
                },
                ".crs": function (a) {
                    if (a.context.IsLotteryTicket) {
                        if (this?.lotteryRates.length > 1) {
                            return shared.floor2(Math.min(...this.lotteryRates), 2) + ' -<br>' + shared.floor2(Math.max(...this.lotteryRates), 2);
                        }
                    }
                    // "RateTicket": kurz, s ktorym bol odd podany - povodny kurz
                    // "Rate": kurz, s ktorym bol odd vyhodnoteny 
                    // Rate = 1 = storno = odd bol vyhodnoteny s tymto kurzom
                    // Rate < 1 = storno a bol odkupeny
                    if (a.context.IsBuyBack) {
                        return this.RateTicket.toFixed(2);
                    }
                    return this.Rate.toFixed(2);
                },
                ".odd-stake": function(a) {
                    if (a.context.IsLotteryTicket) return shared.floor2(this?.Bet, 1) + " " + profile.Currency;
                },
                "@class+": function(a) {
                    var oddClass = "";
                    if (this.IsWinning !== 'BB' && this.Rate <= 1) {
                        oddClass += " is-cancelled";
                    }
                    if (a.context.IsLotteryTicket) oddClass += " lottery-bet";
                    // [Betbuilder Aggregator API] class pre oddy z Betbuilder 
                    if (profile.BetBuilderAgg && this.IsBetbuilder) oddClass += " odd--betbuilder-agg";
                    return oddClass;
                },
                ".+": function(a) {
                    if (a.context.IsLotteryTicket) {
                        return lottery.eventDetailLottery.getDetails(a);
                    } else {
                        return;
                    }
                }
            }
        }
    }
    T.ticketStatusOdds = $p("#ticketStatus #statusOdds tbody").compile(directive);
};

// Direktiva na renderovanie kombinacii pre TicketStatus
directives.ticketDetailDirective.ticketStatusCombi = function() {
    var directive = {
        ".combinations-info": {
            "OddCombi<-OddsCombi": {
                "@class+": function () {
                    return " " + this.IsWinning + " " + ((this.Bet == 0) ? "hide-element" : "");
                },
                "#combinationId": "OddCombi.ID",
                "#combinationBet": function () {
                    return shared.floor2(this.Bet, 1) + " " + profile.Currency;
                },
                "#combinationRate": function () {
                    return shared.floor2(this.Rate, 2);
                },
                "#combinationWin": function () {
                    return shared.floor2(this.PotWin, 1) + " " + profile.Currency;
                }
            }
        }
    }
    T.ticketStatusCombi = $p("#ticketStatus #statusCombinationsWrap").compile(directive);
};

// Direktiva na renderovanie historie editacie tiketu pre TicketStatus
directives.ticketDetailDirective.ticketStatusEditHistory = function () {
    var directive = {
        ".edit-info": {
            "edited<-": {
                "@class+": function () {
                    if (stored.OriginalInputTicket && stored.OriginalInputTicket.PlaceBetTicketCode) {
                        if (stored.OriginalInputTicket.PlaceBetTicketCode === this.TicketCode) {
                            this.actualTicketView = true;
                            // Zvyraznenie aktualneho tiketu v editacnej historii
                            return " actual-ticket-view";
                        }
                    } else {
                        var err = "ticketStatusEditHistory() when !stored.OriginalInputTicket || !stored.OriginalInputTicket.PlaceBetTicketCode";
                        main.createLog(2, "ticketStatusEditHistory_Failed " + err, "stored.OriginalInputTicket: " + JSON.stringify(stored.OriginalInputTicket) + " this: " + JSON.stringify(this));
                        main.closeDialog();
                        modal.showErrObj(2, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
                        throw err;
                    }
                },
                "@onmousedown": function () {
                    if (this.TicketCode === stored.OriginalInputCode) {
                        return "ticketDetail.barCodeTicketInput('" + stored.OriginalInputGUID + "', true)";
                    } else if (!this.actualTicketView) {
                        return "ticketDetail.ticketCodeTicketInput('" + this.TicketCode + "', true)";
                    }
                },
                "#editDate": function () {
                    if (this.TicketStatus === "edited") {
                        return texts.TicketEditVersionLabel + " " + this.EditVersion;
                    } else if (this.Created) {
                        return this.Created.substr(8, 2) + "." + this.Created.substr(5, 2) + "." + this.Created.substr(0, 4) + "  " + new Date(this.Created).toLocaleTimeString(['sk'], { hour: '2-digit', minute: '2-digit' });
                    }
                },
                "#editRate": function () {
                    return shared.floor2(this.TicketRate, 2);
                },
                "#editWinValue": function () {
                    return shared.floor2(this.AmountMoneyWinWithBonus, 1) + " " + profile.Currency;
                },
                ".btn-right@class+": function () {
                    if (!this.actualTicketView) {
                        return " active";
                    }
                }
            }
        }
    }
    T.ticketStatusEditHistory = $p("#ticketStatus #statusEditHistoryWrap").compile(directive);
};
